export enum FieldValueType {
  PERSON_NAME = 'PERSON_NAME',
  COMMENT = 'COMMENT',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  POSTCODE = 'POSTCODE',
  TITLE = 'TITLE',
  ADDRESS = 'ADDRESS',
  SUBURB = 'SUBURB',
  STATE = 'STATE',
  PROVIDER = 'PROVIDER',
  CLINIC = 'CLINIC',
  SCALE = 'SCALE',
  PADNUM = 'PADNUM',
  YESNO = 'YESNO',
  DATE = 'DATE',
  DYNAMIC = 'DYNAMIC',
}

export const validateString = (valueType: FieldValueType, required: boolean, value: string): boolean => {
  let isValid = false
  let match = null
  if (!value) {
    return false
  }
  switch (valueType) {
    case FieldValueType.PERSON_NAME:
      match = value.match("^[a-zA-Z]+[a-zA-Z0-9'\\s-]*$")
      break
    case FieldValueType.COMMENT:
      //It accepts alphanumeric, slash, hyphen, single quote, @, period, comma or space , ( ) " ? <> # % &.
      match = value.match('^[a-zA-Z0-9/\'"\\s-,.()<>@?#%&]+$')
      break
    case FieldValueType.EMAIL:
      match = value.match("^[a-zA-Z0-9.'_-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$")
      break
    case FieldValueType.PHONE:
      match = value.match('^0[23478][0-9]{8}$')
      break
    case FieldValueType.POSTCODE:
      match = value.match('^[0-9]{4}$')
      break
    case FieldValueType.TITLE:
      match = value.match("^[a-zA-Z/'.]{2,10}$")
      break
    case FieldValueType.ADDRESS:
      match = value.match("^[a-zA-Z0-9/'\\s,-]+$")
      break
    case FieldValueType.SUBURB:
      match = value.match("^[a-zA-Z0-9'\\s,-]+$")
      break
    case FieldValueType.STATE:
      match = value.match('^[A-Z]{2,3}$')
      break
    case FieldValueType.PROVIDER:
      match = value.match('^(\\d{5,6})([0123456789ABCDEFGHJKLMNPQRTUVWXY])([YXWTLKJHFBA])$')
      break
    case FieldValueType.CLINIC:
      match = value.match("^[a-zA-Z]+[a-zA-Z0-9+'\\s-()&]+$")
      break
    case FieldValueType.SCALE:
      match = value.match('^[0-9]{1,2}$')
      break
    case FieldValueType.PADNUM:
      match = value.match('^[0-9]{1,2}$')
      break
    case FieldValueType.YESNO:
      match = value.match('^[YesNo]{2,3}$')
      break
    case FieldValueType.DATE:
      match = value.match('^[0-9]{2}/[0-9]{2}/[0-9]{4}$')
      break
  }

  isValid = match !== null && match.length > 0
  isValid = !isValid ? !required && value.length == 0 : isValid

  return isValid
}

// export const debounce = (callback: (any[]) => {}, delay: number): (() => void) => {
//   // eslint-disable-next-line @typescript-eslint/no-explicit-any
//   let timer: any
//   // eslint-disable-next-line @typescript-eslint/no-explicit-any
//   return (...args: any) => {
//     clearTimeout(timer)
//     timer = setTimeout(() => {
//       callback(...args)
//     }, delay)
//   }
// }
